import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getApiV2CustomersCustomerIdFavoriteProducts,
  getFavoriteProductsPath,
} from '@hungryroot/rest/api/v2/customers/[id]/favorite_products/get';

type OptionType = Pick<UseQueryOptions, 'enabled'>;

function useGetFavoriteProducts(customerId: number, options: OptionType = {}) {
  return useQuery({
    queryKey: [getFavoriteProductsPath({ customerId })],
    queryFn: async () => {
      const resp = await getApiV2CustomersCustomerIdFavoriteProducts({
        customerId,
      });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}

export function useIsFavoriteProduct(
  customerId: number,
  productId: number,
  options: OptionType = {}
) {
  const result = useGetFavoriteProducts(customerId, options);

  const isFavorited = result?.data?.favorite_products.some(
    (obj) => obj.product_id === productId
  );

  return { ...result, isFavorited };
}
